import React from 'react';
import styled from 'styled-components';

// 页脚容器
const StyledFooter = styled.footer`
  width: 100%;
  padding: 2rem;
  background-color: #f8f9fa;
  border-top: 1px solid #e9ecef;
  text-align: center;
  color: #6c757d;
  font-size: 0.9rem;
  box-sizing: border-box;
`;

const Footer = () => {
  return (
    <StyledFooter>
      <p>Copyright © 2006-2026 South Wisdom International Development Limited. All right reserved.</p>
    </StyledFooter>
  );
};

export default Footer;